import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { ScopeOfWorkListConfig } from "src/app/inspection/permissions-setter/permissions-interface";
import { ScreenInfo } from "src/app/settings/models/screen-info";
import { ToggleSection } from "src/app/inspection/new-inspection/models/toggle-section";

@Component({
  selector: "im-sow-creation",
  templateUrl: "./sow-creation.component.html",
  styleUrls: ["./sow-creation.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SowCreationComponent {
  @Input()
  sections: any[];

  @Input()
  controls: any[];

  @Input()
  formValues: any[];

  @Input()
  config: ScopeOfWorkListConfig;

  @Input()
  defaultFormId: string;

  @Input()
  toggleSections: ToggleSection[] = [];

  @Input()
  created: boolean;

  @Input()
  sowScreens: ScreenInfo[] = [];

  @Output()
  toggleChanged: EventEmitter<ToggleSection> =
    new EventEmitter<ToggleSection>();

  @Output()
  sowFormChanged: EventEmitter<string> = new EventEmitter<string>();

  isLoadingForm: boolean = false;

  constructor() {}

  onSelectedSections(selectedSection: ToggleSection) {
    selectedSection.selected = !selectedSection.selected;
    this.toggleChanged.next(selectedSection);
  }

  onSowFormChanged(formId: string) {
    this.sowFormChanged.next(formId);
  }

  onLoadingNewForm(isLoading: boolean) {
    this.isLoadingForm = isLoading;
  }
}
